<template>
  <BaseCard>
    <BaseCardHeader>
      <div>
        <h3 class="text-lg leading-6 font-medium text-gray-900">Delete SMS campaign</h3>
        <p class="max-w-2xl text-sm text-gray-500">Permantly delete this campaign.</p>
      </div>
    </BaseCardHeader>
    <BaseCardBody>
      <p class="text-gray-800 measure">
        Once a campaign is deleted, all related resources will also be deleted.
      </p>
    </BaseCardBody>
    <BaseCardFooter gray>
      <SmsCampaignDestroyForm :sms-campaign-id="smsCampaign.id" />
    </BaseCardFooter>
  </BaseCard>
</template>

<script>
import SmsCampaignDestroyForm from './SmsCampaignDestroyForm.vue';

export default {
  components: { SmsCampaignDestroyForm },
  props: {
    smsCampaign: {
      type: Object,
      required: true,
    },
  },
};
</script>
